import cn from 'classnames';
import type { ArticleCard } from 'modules/magazine/contentful';
import Image from 'modules/content-cms/sections/components/image';
import renderDocument from 'modules/content-cms/util/render-document';
import Link from 'next/link';
import React, { ReactNode } from 'react';
import { formatDate, getMagazineUrl } from '../../util';
import style from './blog-tile.module.css';

interface BlogTileProps {
  article: ArticleCard;
  isMagazineHome?: boolean;
}

const BlogTile: React.FC<BlogTileProps> = ({ article, isMagazineHome }) => {
  // Blog Tile title has different html tags between magazin home and main/sub category pages for SEO
  const renderBlogTileTitle = (): ReactNode => {
    return isMagazineHome ? (
      <h3 className="line-clamp-2 min-h-16">{article.title}</h3>
    ) : (
      <h2 className="line-clamp-2 min-h-16">{article.title}</h2>
    );
  };

  return (
    <Link
      href={getMagazineUrl({
        mainCategory: article.mainCategory.fields,
        subCategory: article.subCategory?.fields,
        blogPost: article,
      })}
    >
      <div
        className={
          'border-grey-50 flex min-h-96 max-w-sm cursor-pointer flex-col rounded-2xl border shadow-xs lg:hover:shadow-lg'
        }
      >
        <div className={'relative h-44 w-full'}>
          <Image
            {...article.blogImage}
            className="h-44 rounded-t-xl"
            data-test="blog-image"
            layout={'fill'}
            objectFit={'cover'}
            placeholder={'blur'}
            blurDataURL="/images/petsdeli-logo.svg"
          />
        </div>
        <div className={'relative flex-1 px-6 py-2'}>
          <div className={'text-primary-main mb-4 block text-2xl font-black'}>
            {renderBlogTileTitle()}
          </div>

          <div className={cn('line-clamp-2', style.normalize)}>
            {renderDocument(article.description)}
          </div>

          <div className={'absolute right-0 bottom-0 px-6 py-2 uppercase'}>
            {formatDate(article.publishDate)}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BlogTile;
